import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import PagesContent from './PagesContent'
export default class Pages extends Component {

    render() {

        let page = this.props.match.params.page;

        const urlParams = new URLSearchParams(window.location.search);

        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <PagesContent urlParams={urlParams} page={page} />
                <Footer />

            </div>


        )
    }
}
